<template>
	<table :class="tableClass" role="grid">
		<loader v-if="loading"/>
		<slot/>
	</table>
</template>
<script>
	export default {
		computed: {
			tableClass() {
				return {
					loading: this.loading,
				}
			},
		},

		props: {
			loading: {
				type: Boolean,
				default() {
					return false
				}
			},
		},
	}
</script>
